import React from 'react'
import { Typography } from 'antd'

import { Spinner } from 'portal/lib/primitives'

import { AlertsTable } from './AlertsTable'
import { useProjectAlertsLoader } from './useProjectAlertsLoader'
import { useRecordAlertsLoader } from './useRecordAlertsLoader'

export const AlertsTableWrapper = ({
  startDate,
  endDate,
  showDismissed,
  allowSelectionAndAction
}) => {
  const {
    loading: projectAlertsLoading,
    error: projectAlertsError,
    reload: projectAlertsReload
  } = useProjectAlertsLoader(startDate, endDate)
  const {
    loading: recordAlertsLoading,
    error: recordAlertsError,
    reload: recordAlertsReload
  } = useRecordAlertsLoader(startDate, endDate)

  const { Text } = Typography

  const reload = () => {
    projectAlertsReload()
    recordAlertsReload()
  }

  return (
    <>
      {(projectAlertsError || recordAlertsError) && (
        <Text type="danger">
          There was a problem loading this page, please try again
        </Text>
      )}
      {(projectAlertsLoading || recordAlertsLoading) && <Spinner />}
      {!projectAlertsError && !recordAlertsError && (
        <AlertsTable
          showDismissed={showDismissed}
          allowSelectionAndAction={allowSelectionAndAction}
          reload={reload}
        />
      )}
    </>
  )
}
